import TransactionModal from "./transactionModal.js";

export default class InviteCompanyModal extends TransactionModal {
  constructor(companyId) {
    super("invite-company-modal", companyId);
    this.$email = this.$form.querySelector('[name="email"]');
    this.$companyName = this.$form.querySelector('[name="company-name"]');
    this.isCompanyNameManuallyFilled = false;

    this.formFields = [
      {
        name: "company",
        varType: "int",
      },
      {
        name: "email",
        required: true,
      },
      {
        name: "name",
        required: true,
      },
      {
        name: "company_name",
      },
    ];

    this.whenReady();
    this.setupListeners();
  }

  showCompanyName(enable, inviterLink) {
    const $container = this.$companyName.parentElement.parentElement;
    if (enable) {
      $container.classList.remove("d-none");
    } else {
      $container.classList.add("d-none");
    }

    document.querySelectorAll("[data-share-on-whatsapp]").forEach((el) => {
      if (enable) {
        el.removeAttribute("style");
      } else {
        el.style.display = "none";
      }
      const $a = el.querySelector("a");
      if ($a) {
        $a.href = inviterLink;
      }
    });
  }

  setupListeners() {
    this.$companyName.addEventListener("focusout", () => {
      this.isCompanyNameManuallyFilled = true;
    });

    this.$email.addEventListener("input", () => {
      if (
        !this.$email.value.includes("@") ||
        this.isCompanyNameManuallyFilled
      ) {
        return;
      }
      let companyName = this.$email.value.split("@")[1];
      companyName = companyName.split(".")[0];
      companyName = companyName.charAt(0).toUpperCase() + companyName.slice(1);
      this.$companyName.value = companyName;
    });
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        peque.api("companies/invite", data, "post").then((response) => {
          peque.navigation.showSuccess("").then((response) => {
            location.reload();
          });
        });
      })
      .catch((error) => {
        this.enableSubmitButton(true);
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
